import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import LabelAndSelectChange from '../form/labelAndSelectChange';
import { getConfig } from '../../configuracao/configLocal';

import { getControladorAnelList } from './selectdbAtions';

class SelectAnelControlador extends Component {
  constructor(props) {
    super(props);

    this.props.getControladorAnelList();

    this.state = {
      value: this.props.value,
      filterGrupo: getConfig('grupo'),
      filterNumCont: getConfig('numCont'),
    };
  }

  componentDidUpdate(prevProps) {
    const grupo = getConfig('grupo');
    const numCont = getConfig('numCont');

    if (grupo !== this.state.filterGrupo || numCont !== this.state.filterNumCont) {
      this.setState({
        filterGrupo: grupo,
        filterNumCont: numCont,
      });
    }

    if (prevProps.value !== this.props.value && this.props.value !== this.state.value) {
      this.setState({ value: this.props.value });
    }
  }

  renderOptions() {
    const list = this.props.list || [];
    const grupoFisico = this.props['data-grupofisico'] || getConfig('grupo');
    const numControlador = this.props['data-num-controlador'] || getConfig('numCont');

    if (!grupoFisico || !numControlador) {
      return null;
    }

    if (list.length === 0) {
      return <option value="">Carregando...</option>;
    }

    const listCont = list.filter(
      cont =>
        String(cont.grupo_fisico_id) === String(grupoFisico) &&
        String(cont.numero_controlador) === String(numControlador) &&
        cont.ativo === 1,
    );

    return listCont.map(contro => (
      <option key={contro.id} value={contro.id} data-anel={contro.anel}>
        {`${contro.anel}`}
      </option>
    ));
  }

  render() {
    return (
      <LabelAndSelectChange
        id={this.props.id}
        name={this.props.name}
        label={this.props.label}
        cols={this.props.cols}
        onChange={this.props.onChange}
        value={this.props.value}
      >
        <option value="Selecionar">Selecionar</option>
        {this.renderOptions()}
      </LabelAndSelectChange>
    );
  }
}

const mapStateToProps = state => ({ list: state.controladorCad.listAnel });
const mapDispatchToProps = dispatch => bindActionCreators({ getControladorAnelList }, dispatch);
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SelectAnelControlador);
